import { fg } from '@atlaskit/platform-feature-flags/fg';
import {
	isTerminalTaskState,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { getLastAgentMessageID } from './getLastAgentMessageID';
import { shouldRestoreMaxModeFromLastRequestedMode } from './shouldRestoreMaxModeFromLastRequestedMode';
import type { ChatStoreAction } from './types';

export const restoreTaskModeForConversation =
	({
		conversationId,
		messages,
	}: {
		conversationId: string;
		messages: StoreChatItem[];
	}): ChatStoreAction =>
	({ getState }, { setReasoningMode, unifiedTasksActions }) => {
		if (!fg('rovo_chat_enable_tasks') || !unifiedTasksActions) {
			return;
		}

		const activeTask = unifiedTasksActions.getActiveTaskForConversation(conversationId);
		const lastAgentMsgId = getLastAgentMessageID(messages);
		if (
			activeTask &&
			!isTerminalTaskState(activeTask.progressState) &&
			lastAgentMsgId &&
			activeTask.currentMessageId === lastAgentMsgId &&
			shouldRestoreMaxModeFromLastRequestedMode(
				getState().conversations[conversationId]?.lastRequestedMode,
			)
		) {
			setReasoningMode(conversationId, 'task');
		}
	};
